import { useBrowseLink } from 'hooks/useBrowseLink';
import { analytics } from 'utils/analytics';
import {
    CtaGoal,
    CtaType,
    InteractionSource,
} from 'utils/analytics/AnalyticsV2Service.generated';
import { useCreatorContext } from 'controllers/business/Creator/Creator.controller';
import { DefaultCreatorConfig } from 'controllers/business/Creator/helpers/misc.helpers';
import { RoutePaths } from 'types/enums';

export const useCreatorFooter = () => {
    const { closeCreator, state } = useCreatorContext();
    const samplesCount = state.samplesInSession.size;
    const showCreatorFooter = samplesCount < DefaultCreatorConfig.MAX_TRACKS;

    const creatorBaseClick = () => {
        // Make sure we load at top of the page
        window.scrollTo(0, 0);
        closeCreator();
    };

    const addSampleLink = useBrowseLink();
    const handleAddSampleClick = () => {
        creatorBaseClick();

        analytics.trackCTAClicked({
            ctaGoal: CtaGoal.BrowseSamples,
            ctaType: CtaType.Button,
            interactionSource: InteractionSource.CreatorAction,
            ctaText: 'Add a loop',
            ctaDestination: `/${RoutePaths.Browse}?Type=loop`,
        });
    };

    return {
        addSampleLink,
        showCreatorFooter,
        handleAddSampleClick,
    };
};
